<template>
  <div class="col-10 col-xl-7 mx-auto">
    <div class="row">
      <div class="col-8">
        <breadcrumbs class="text-muted bg-light py-3"></breadcrumbs>
      </div>
      <div v-if="!isOnSelectPlatformPage" class="col-4 py-3 d-flex justify-content-end">
        <router-link :to="{name: 'administration.channels.new'}"
                     class="text-muted">
          <icon class="btn-icon" name="arrow-left"/>
          Go Back
        </router-link>
      </div>
    </div>
    <div class="row p-5 bg-white rounded">
      <div class="col-12">
        <div>
          <platform-list v-if="!selectedPlatform"></platform-list>
          <platform-specific v-else></platform-specific>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import Breadcrumbs from '@/components/common/Breadcrumbs'
  import PlatformList from '@/components/administration/channel/new-channel-wizard/PlatformList'
  import PlatformSpecific from '@/components/administration/channel/new-channel-wizard/PlatformSpecific'
  import 'vue-awesome/icons/arrow-left' // importing for all children's

  export default {
    metaInfo: {
      title: 'New Channel'
    },

    components: {
      'breadcrumbs': Breadcrumbs,
      'platform-specific': PlatformSpecific,
      'platform-list': PlatformList
    },

    computed: {
      selectedPlatform() {
        return this.$route.query.platform
      },

      isOnSelectPlatformPage() {
        return !this.selectedPlatform
      }
    }
  }
</script>
